import Cookies from 'js-cookie/src/js.cookie';

const cookieWarning = () => {
  if (Cookies.get('cookieMonsterSuppressed') !== 'true') {
    const cookieWarningElem = document.querySelector('[data-cookie-warning]')

    if (!cookieWarningElem) {
      console.error('Could not find Cookies tin! Please create one!');
      return;
    }

    cookieWarningElem.classList.remove('hide');

    document.querySelector('[data-cookie-warning-btn]').addEventListener('click', () => {
      cookieWarningElem.classList.add('hide');
      Cookies.set('cookieMonsterSuppressed', 'true', { expires: 31 });
    });
  }
}

export default cookieWarning;